// extracted by mini-css-extract-plugin
export var addToCartButton = "_s3-b";
export var arrowButtonContainer = "_s3-9";
export var arrowButtonIcon = "_s3-a";
export var carouselArrowButton = "_s3-6";
export var carouselElementContainer = "_s3-1";
export var left = "_s3-7";
export var productDisplayCarouselContainer = "_s3-0";
export var productTileContainer = "_s3-2";
export var productTileImage = "_s3-4";
export var productTileImageContainer = "_s3-3";
export var productTileTitle = "_s3-5";
export var right = "_s3-8";
export var sliderOverflow = "_s3-c";